import {emojiRender} from "./templates/renders/emoji";

/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

const EmojiPicker: any = {
    tagName: "emoji-picker",
    initialize(options) {
        initComponent(options);
    },
    renderer: emojiRender,
    created() {
        this.emoji = this.el.firstElementChild;
    },
    setVisible(visibility) { // eslint-disable-line no-unused-vars
        this.emoji.classList.toggle("active");
    },
    search(e) {
        const query = e.target.value;

        if (query != "") {
            const els = document.querySelectorAll(`.emoji-picker-emoji:not([title*='${query}'])`);
            els.forEach((el: any) => {
                el.style.display = "none";
            });
        } else {
            const els = document.querySelectorAll(".emoji-picker-emoji");
            els.forEach((el: any) => {
                el.style.display = "";
            });
        }
    },
    onSelected(e) {
        if (e.target.classList.contains("emoji-picker-emoji")) {
            this.inputEl.insertEmoji(e.target.innerHTML);
            this.setVisible(false);
        }
    },
    setInputElement(input) {
        this.inputEl = input;
    },
};

export default appInstance => {
    EmojiPicker.$app = appInstance;
    return EmojiPicker;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const footerConfig = appInstance.getUIConfig().footerConfig || {};

    if (footerConfig) {
        options.constants = {
            popoverStyles: footerConfig.emojiPickerPopoverStyles,
            pickerStyles: footerConfig.emojiPickerContainerStyles,
            caretStyles: footerConfig.emojiPickerCaretStyles,
        };
    }
};
